module.exports = __webpack_public_path__ + "images/backgrounds/city/large.d23508735801f1190b36.jpg";